<template>
<div class="toast-wrap" :class="{mb: mb}">
    <div class="toast"></div>
    <div class="txt">{{ txt }}</div>
</div>
</template>
<script>

export default {
    name: 'toastwrap',
    props: {
        txt: { type: String, default: '' },
        mb: { type: String, default: '' }
    },
    data() {
        return {
        };
    },
    components: {
    },
    methods: {
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}
.toast-wrap {
    position: absolute;
    width: 200px;
    // min-height: 50px;
    box-sizing: border-box;
    left: 50%;
    margin-left: -100px;
    top: 50%;
    margin-top: -25px;
    &.mb {
        width: rem(200);
        // min-height: rem(50);
        margin-left: rem(-100);
        margin-top: rem(-25);
        .toast {
            border-radius: rem(8);
        }
        .txt {
            line-height: 1.5;
            padding: rem(12) rem(8);
        }
    }
    .toast {
        position: absolute;
        width: 100%;
        height: 100%;
        background:rgba(0,0,0,1);
        border-radius:8px;
        opacity:0.7;
    }
    .txt {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
        font-size: 16px;
        padding: 12px 8px;
        box-sizing: border-box;
        font-family: 'RobotoRegular';
        font-weight: 400;
        color: rgba(255,255,255,1);
        line-height: 1.5;
        word-break: break-word;
    }
    // width:200px;
    // height:49px;
    // background:rgba(0,0,0,1);
    // border-radius:8px;
    // opacity:0.7;
}
</style>
